import { Component } from '@angular/core';

@Component({
  selector: 'app-insight-egrc',
  templateUrl: './insight-egrc.component.html',
  styleUrls: ['./insight-egrc.component.scss']
})
export class InsightEgrcComponent {

}
